import { css } from 'styled-components';
import { typographyPresets } from '@agilepoint/wat-react-ux';

export const commonStyles = {
    textOverflow: css`
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    `,
    fullWidth: css`
        width: 100%;
    `,
    fullHeight: css`
        height: 100%;
    `,
    navResultContentBlock: css`
        width: calc(100% - 32px);
        height: calc(100% - 16px);
        margin: 0px 0px 0px 20px;
    `,
    outlineColor: css`
        outline-color: ${({ theme: { semantics: { palette } } }) => palette.themePrimary};
    `,
    outlineStyle: css`
        outline: ${({ theme: { semantics: { palette } } }) => palette.themePrimary} auto 1px;
    `,
    outlineOffset: css`
        :focus {
        outline-offset: 5px;
    }  
    `,
    boldTextLabel: css`
        .ap-label, .ap-label > span {
            ${typographyPresets.headings.h5};
        }
    `,
    primartButtonStyles: css`
        background-color: ${({ theme }) => theme.mobileAppAccelerator.semanticColors.apStandardBlueColor};
        border-radius: 22px;
        :disabled {
            background: #80BBEC;
            border-radius: 22px;
        }
    `,
    standardHeadingStyles: css`
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
    `,
    secondaryHeadingStyle: css`
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
    `
};

export const cssStyles = [
    'padding: 0px;',
    '.ap-popup-header-wrapper {display: flex;background-color: #F1F2F4;height: 32px;}',
    '.ap-popup-close-icon {position: absolute; top: 0; right: 0; }',
    '.ap-popup-content {padding: 25px 30px 0px 30px;}'
];
